
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/philanthropy",
      function () {
        return require("private-next-pages/about-us/philanthropy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/philanthropy"])
      });
    }
  